module.exports = __webpack_public_path__ + "static/media/check_selected.5ff80915.svg";